module.exports = __webpack_public_path__ + "img/frost.58812348.jpg";